import styled, { keyframes } from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const SubscriptionPaymentStatusPageContainer = styled.div`
  font-family: "Outfit", sans-serif;

  .main-container-payment-status {
    padding: 70px 0;
  }

.main-container-payment-status .board {
    border: 1px solid #cccc;
    width: auto;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
    padding: 40px;
    border-radius: 20px;
    box-shadow: rgba(0,0,0,0.25) 0px 5px 15px;
    background: linear-gradient(135deg,#fff9eb 0%,#ee2d2f0f 100%);
    color: #000;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.payment_status_boxed {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.try-again-parent .customs_btn {
    padding: 15px 26px !important;
}
  .pageheading_section {
    text-align: center;
  }

  /* Success Circle */
  .checkmark-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    background-color: #719a54;
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: ${pulse} 2s ease-in-out infinite;
  }

  .checkmark {
    width: 70px;
    height: 70px;
  }

  .checkmark-circle {
    fill: none;
    stroke: #719a54;
    stroke-width: 4;
  }

  .checkmark-check {
    fill: none;
    stroke: #fff;
    stroke-width: 4;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  /* Failure Circle */
  .checkmark-wrapper-fail {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    background-color: #e74c3c; /* red */
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: ${pulse} 2s ease-in-out infinite;
  }

  .checkmark-fail {
    width: 70px;
    height: 70px;
  }

  .checkmark-circle-fail {
    fill: none;
    stroke: #e74c3c;
    stroke-width: 4;
  }

  .checkmark-x {
    fill: none;
    stroke: #fff;
    stroke-width: 4;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .main-container-payment-status .board h3 {
        font-size: 28px;
        margin-top: 12px;
    }
.main-container-payment-status .board button.customs_btn {
    padding: 8px 25px !IMPORTANT;
}
  @media (max-width: 1199px) {
    .checkmark-wrapper,
    .checkmark-wrapper-fail {
      width: 100px;
      height: 100px;
    }

    .checkmark,
    .checkmark-fail {
      width: 50px;
      height: 50px;
    }
  }

  @media (max-width: 767px) {
    .checkmark-wrapper,
    .checkmark-wrapper-fail {
      width: 80px;
      height: 80px;
    }

    .checkmark,
    .checkmark-fail {
      width: 40px;
      height: 40px;
    }
  }
`;
